<script setup>
import { ref, watch, onBeforeMount, toRefs } from 'vue'

import { useUsuario } from '@/stores/services/usuarios'
import { formatNewDateTimeView } from '@/utils/date-fns'
import { useCriticasIntrajornada } from '@/stores/services/criticasIntrajornada'

import FiltroCriticasIntrajrnada from '../components/FiltroCriticasIntrajornada.vue'

const { obterAcessos } = useUsuario()
const { obterCriticasIntrajornada, exportarCriticasIntrajornadaCsv } = useCriticasIntrajornada()
const { loadingCriticasIntrajornada, sucessoRelatorio, criticasIntrajornada } = toRefs(useCriticasIntrajornada())

const form = ref({
  pagina: 1,
  limite: 10
})
const filtro = ref(null)
const request = ref(false)

const obterPayloadPeriodo = (value) => (filtro.value = value)
const obterRequest = (value) => (request.value = value)

const atualizarRelatorios = async () => {
  if (filtro.value?.dataInicio) {
    await obterCriticasIntrajornada({ ...form.value, ...filtro.value })
  }
}

watch(
  () => filtro.value,
  async () => atualizarRelatorios()
)
watch(
  () => request.value,
  async () => atualizarRelatorios()
)
const onPage = async (event) => {
  form.value.pagina = event.page + 1
  form.value.limite = event.rows
  atualizarRelatorios()
}
const gerarRelatorio = async () => await exportarCriticasIntrajornadaCsv({ ...form.value, ...filtro.value })

const iniciar = async () => {
  await obterAcessos()
  await atualizarRelatorios()
}

onBeforeMount(iniciar)
</script>
<template>
  <AlertaGerarRelatorio :ativarAlerta="sucessoRelatorio" nomeGrupo="criticasIntrajornada" />
  <Progress :active="loadingCriticasIntrajornada" />
  <div class="mb-6 nc-panel">
    <FiltroCriticasIntrajrnada @enviarPayloadFiltro="obterPayloadPeriodo" @enviarRequest="obterRequest" />
  </div>
  <div class="container mb-6">
    <div class="flex justify-content-end align-items-center">
      <Button type="button" icon="pi pi-file-excel " @click="gerarRelatorio()" class="p-button-text green" label="exportar csv" />
    </div>
    <div class="card mt-3">
      <DataTable
        v-if="criticasIntrajornada?.items"
        :rows="10"
        dataKey="id"
        filterDisplay="row"
        :totalRecords="criticasIntrajornada?.totalDeRegistros"
        :value="criticasIntrajornada?.items"
        responsiveLayout="scroll"
        :lazy="true"
        :loading="loadingCriticasIntrajornada"
        :paginator="true"
        @page="onPage($event)"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="{totalRecords} registro(s)"
      >
        <Column field="funcionario.matricula" style="min-width: 200px" header="Matrícula"></Column>
        <Column field="funcionario.nome" style="min-width: 200px" header="Nome"></Column>
        <Column field="escala.data" style="min-width: 200px" header="Data"></Column>
        <Column field="escala.detalhe" style="min-width: 200px" header="Escala"></Column>
        <Column field="duracaoTotalCriticaIntraJornada" style="min-width: 200px" header="Duraç. do Servi."></Column>
        <Column field="duracaoCriticaIntraJornada1" style="min-width: 200px" header="Intra. 1"></Column>
        <Column field="concessaoIntraJornada1" style="min-width: 200px" header="Início Conc. 1"></Column>
        <Column field="duracaoCriticaIntraJornada2" style="min-width: 200px" header="Intra. 2"></Column>
        <Column field="concessaoIntraJornada2" style="min-width: 200px" header="Início Conc. 2"></Column>
        <Column field="duracaoCriticaIntraJornada3" style="min-width: 200px" header="Intra. 3"></Column>
        <Column field="concessaoIntraJornada3" style="min-width: 200px" header="Início Conc. 3"></Column>
        <Column field="regrasDaIntraJornadaAtendidas" style="min-width: 200px" header="Regras Intra. Atendidas"></Column>
        <Column field="duracaoIntraJornadaAdequadaComServico" style="min-width: 200px" header="Duração da Intra. Ade. com a Dura. Serviç."></Column>
        <Column field="intrajornadaConcedidaEntre4e6HoraServico" style="min-width: 200px" header="Intra. Conc. Entre a 4ª e 6ª Serviç."></Column>
        <Column field="intrajornadaFinalJornadaServico" style="min-width: 200px" header="Intra. no Final da Jorn. Serviç."></Column>
        <Column field="intrajornadaApos8HoraServico" style="min-width: 200px" header="Intra. Após a 8ª Hora de Serviç."></Column>
        <template #paginatorstart>
          <Button type="button" icon="pi pi-refresh" @click="atualizarRelatorios()" class="p-button-text" />
          <span style="position: absolute; padding-top: 5px">atualizado em: {{ formatNewDateTimeView() }}</span>
        </template>
      </DataTable>
    </div>
    <div class="card flex justify-content-center card mt-3" v-if="!criticasIntrajornada" style="background-color: #fff; padding: 40px">
      <span><i class="pi pi-search-minus mr-2"></i>Nenhum registro encontrado</span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.nc-panel {
  width: 100%;
  padding-top: 50px;
}
</style>
